/* ============================================================
   STENS — Interactive World Map
   Loads SVG, highlights dealer countries, click to show popup
   ============================================================ */
(function() {
  'use strict';

  // Dealer presence data — country code (ISO 3166-1 alpha-2) → info
  const DEALERS = {

    'tr': { name: 'Turkey', dealers: 1, cities: 'Ankara' },
    'ae': { name: 'United Arab Emirates', dealers: 1, cities: 'Dubai' },
  };

  async function loadAndInit(container) {
    if (!container) return;
    try {
      let svgText = null;

      // 1. Try embedded global (works on file:// protocol)
      if (typeof window.STENS_WORLD_MAP_SVG === 'string' && window.STENS_WORLD_MAP_SVG.length > 100) {
        svgText = window.STENS_WORLD_MAP_SVG;
      } else {
        // 2. Fallback to fetch (works on http server)
        const res = await fetch((window.STENS_ASSET_BASE||'') + 'world-map.min.svg');
        if (!res.ok) throw new Error('Map fetch failed');
        svgText = await res.text();
      }

      container.innerHTML = svgText;
      const svg = container.querySelector('svg');
      if (!svg) return;
      enhanceMap(svg, container);
    } catch (e) {
      container.innerHTML = '<div style="color: var(--c-text-muted); text-align: center; padding: 2rem; font-size: 0.85rem;">Map unavailable</div>';
    }
  }

  function enhanceMap(svg, container) {
    // Make sure SVG fits and is responsive
    svg.removeAttribute('width');
    svg.removeAttribute('height');
    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');

    // Crop viewBox - both pages now show full world (referans matches)
    const isDealersPage = container.closest('.dealers-page-map') !== null;
    if (!isDealersPage) {
      // Show full world but slightly tighter top crop (cut some empty antarctica/arctic)
      svg.setAttribute('viewBox', '50 80 920 540');
    }

    // Mark dealer countries
    const allPaths = svg.querySelectorAll('path[id]');
    allPaths.forEach(path => {
      const id = path.getAttribute('id');
      if (DEALERS[id]) {
        path.setAttribute('data-has-dealer', 'true');
        const dealer = DEALERS[id];
        // Add accessible title
        const title = document.createElementNS('http://www.w3.org/2000/svg', 'title');
        title.textContent = `${dealer.name} — ${dealer.dealers} dealer${dealer.dealers > 1 ? 's' : ''}`;
        path.appendChild(title);
      }
    });

    // Create popup
    const popup = document.createElement('div');
    popup.className = 'map-popup';
    popup.setAttribute('role', 'tooltip');
    container.appendChild(popup);

    // Click/hover handlers
    let activePath = null;
    let popupHover = false;

    function showPopup(path, dealer) {
      // Position popup at country center
      const containerRect = container.getBoundingClientRect();
      const pathRect = path.getBoundingClientRect();
      const x = pathRect.left - containerRect.left + pathRect.width / 2;
      const y = pathRect.top - containerRect.top;

      popup.innerHTML = `
        <div class="map-popup-country">${escapeHtml(dealer.name)}</div>
        <div class="map-popup-meta">${dealer.dealers} authorized dealer${dealer.dealers > 1 ? 's' : ''}</div>
        <div class="map-popup-info">${escapeHtml(dealer.cities)}</div>
        <a href="/pages/dealer?country=${encodeURIComponent(path.getAttribute('id'))}" class="map-popup-link">
          View dealer details <span class="arrow">→</span>
        </a>
      `;
      popup.style.left = x + 'px';
      popup.style.top = y + 'px';
      popup.classList.add('is-visible');
    }

    function hidePopup() {
      popup.classList.remove('is-visible');
      if (activePath) {
        activePath.classList.remove('is-active');
        activePath = null;
      }
    }

    // Track popup hover so we don't close while user is moving toward it
    popup.addEventListener('mouseenter', () => { popupHover = true; });
    popup.addEventListener('mouseleave', () => {
      popupHover = false;
      if (!activePath) hidePopup();
    });

    svg.addEventListener('click', (e) => {
      const path = e.target.closest('path[data-has-dealer="true"]');
      if (!path) {
        hidePopup();
        return;
      }
      e.stopPropagation();
      const id = path.getAttribute('id');
      const dealer = DEALERS[id];
      if (!dealer) return;

      if (activePath === path) {
        hidePopup();
        return;
      }

      if (activePath) activePath.classList.remove('is-active');
      activePath = path;
      path.classList.add('is-active');
      showPopup(path, dealer);
    });

    // Hover on dealer paths — show popup if not already pinned
    svg.addEventListener('mouseover', (e) => {
      const path = e.target.closest('path[data-has-dealer="true"]');
      if (!path || activePath) return;
      const id = path.getAttribute('id');
      const dealer = DEALERS[id];
      if (dealer) showPopup(path, dealer);
    });

    svg.addEventListener('mouseout', (e) => {
      // Only hide if not pinned and mouse not over popup
      if (activePath || popupHover) return;
      // Check if leaving to popup
      const related = e.relatedTarget;
      if (related && (related === popup || popup.contains(related))) return;
      // Small delay to allow moving to popup
      setTimeout(() => {
        if (!activePath && !popupHover) hidePopup();
      }, 100);
    });

    // Click outside to close pinned popup
    document.addEventListener('click', (e) => {
      if (!container.contains(e.target)) hidePopup();
    });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, c => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
  }

  function init() {
    document.querySelectorAll('[data-stens-map]').forEach(loadAndInit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
